import { formatDateTimeList } from "domain/core/utils"

export const columnConfig = [
  {
    field: "userName",
    headerName: "Author",
    width: 216,
    sortable: false,
  },
  {
    field: "action",
    headerName: "Event",
    width: 176,
    sortable: false,
    renderCell: ({ value }) => `${value[0].toUpperCase()}${value.slice(1)}`,
  },
  {
    field: "createdAt",
    headerName: "Time",
    width: 176,
    sortable: false,
    renderCell: ({ value }) => formatDateTimeList(value),
  },
]
